import React from 'react';
import styled from 'styled-components';
import { DposLoyaltyDefault as DposLoyaltyIcon } from 'src/assets/dpos-loyalty-default';
import styledContainerQuery from 'styled-container-query';

import { Button, TextButton } from 'src/components/core';
import { DialogHeading } from 'src/components/modals/components/simple-dialog';
import { Statuses } from 'src/components/loyalty/use-loyalty';
import useErnie from 'shared/hooks/use-ernie';
import { ERNIE_TYPES } from 'shared/constants/ernie';

type ReferralConnectProps = {
  onClose: () => void;
  setStatus: (status: Statuses) => void;
  programName: string;
  programDescription: string;
};

export const ReferralConnect = ({
  onClose,
  setStatus,
  programName,
  programDescription,
}: ReferralConnectProps): JSX.Element => {
  const showErnie = useErnie();
  const handleConnect = (): void => {
    setStatus(Statuses.terms);
  };

  const handleOnClose = (): void => {
    showErnie(
      'You must be a loyalty member to be eligible for the referrals reward. Refresh the page to try again.',
      ERNIE_TYPES.DANGER
    );
    onClose();
  };

  return (
    <>
      <StyledHeading fontSize={20}>Connect Your Account</StyledHeading>
      <Wrapper>
        <DispoInfo>
          <Image>
            <DposLoyaltyIcon />
          </Image>

          <div>
            <Name>{programName}</Name>
          </div>
        </DispoInfo>
      </Wrapper>

      <Content>{programDescription}</Content>

      <Button onClick={handleConnect} mb={16} width='264px'>
        Connect
      </Button>
      <StyledTextButton onClick={handleOnClose}>Not right now</StyledTextButton>
    </>
  );
};

const StyledHeading = styled(DialogHeading)`
  margin-bottom: 24px;
`;

const StyledTextButton = styled(TextButton)`
  font-weight: 600;
`;

const Content = styled.p`
  margin: 24px 0 8px;
  color: #646d72;
  margin-bottom: 32px;
`;

const DispoInfo = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
`;

const Image = styled.div`
  border-radius: 50%;
  color: ${({ theme }) => theme.customized.colors.buttonsLinks};
  display: block;
  height: 56px;
  overflow: hidden;
  width: 56px;
`;

const Name = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: ${18 / 16};
`;

// This is our container query component
const Wrapper = styledContainerQuery.a`
  background: ${({ theme }) => theme.customized.colors.buttonsLinks};
  border-radius: ${({ theme }) => theme.customized.radius.lg};
  color: #fff;
  display: block;
  max-width: 1200px;
  overflow: hidden;
  padding: 20px;
  position: relative;
  width: 100%;
  z-index: 1;
  &::before {
    background: #ffffff1a;
    border-radius: 50%;
    content: '';
    height: 400px;
    left: 48px;
    pointer-events: none;
    position: absolute;
    top: 48px;
    transform: translate(-50%, -50%);
    width: 400px;
    z-index: -1;
  }
  @media only screen and (min-width: 600px) and (max-width: 899px) {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  @media only screen and (min-width: 900px) {
    justify-content: space-between;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    ${DispoInfo} {
      max-width: 275px;
    }
  }
`;
